import { connect } from "react-redux";

function mapStateToProps(state) {
    const {
        config: { bloombergSiteUrl },
        loginRegister = {}
    } = state;

    return {
        bloombergSiteUrl,
        email: loginRegister.email || ""
    };
}

function createSignupNewslettersContainer(component) {
    return connect(
        mapStateToProps,
        null
    )(component);
}

export default createSignupNewslettersContainer;
